export default function toggleHelpWidgetVisibility() {
  let intersectionObserver: IntersectionObserver | null = null
  let resizeObserver: ResizeObserver | null = null

  const cleanup = () => {
    intersectionObserver?.disconnect()
    resizeObserver?.disconnect()
  }

  const calculateWidgetPosition = () => {
    const footer = document.querySelector(".site-footer") as HTMLElement | null
    const zendeskButton = document.querySelector("#zendesk-widget-button .help-button") as HTMLElement | null
    if (!footer || !zendeskButton) return

    const footerTopFromDocument = footer.offsetTop
    const distanceFromBottom = window.innerHeight - footerTopFromDocument
    const bottomPosition = Math.max(distanceFromBottom, 0)
    document.documentElement.style.setProperty("--zendesk-widget-bottom", `${bottomPosition}px`)

    intersectionObserver?.disconnect()

    requestAnimationFrame(() => {
      intersectionObserver = new IntersectionObserver(
        entries => {
          entries.forEach(entry => {
            const widgetRect = zendeskButton.getBoundingClientRect()
            const footerCurrentRect = entry.boundingClientRect
            const isOverlapping = widgetRect.top > footerCurrentRect.top

            zendeskButton.style.visibility = isOverlapping ? "hidden" : "visible"
          })
        },
        { threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.66, 0.75] }
      )

      intersectionObserver.observe(footer)
    })
  }

  calculateWidgetPosition()

  const mainElement = document.querySelector("main")
  if (mainElement) {
    resizeObserver = new ResizeObserver(() => {
      calculateWidgetPosition()
    })
    resizeObserver.observe(mainElement)
  }

  return cleanup
}
